var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceSmile = function SvgFaceSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#73B76F",
    d: "M24.667 16a8.667 8.667 0 1 0-17.334 0 8.667 8.667 0 0 0 17.334 0M5.333 16a10.667 10.667 0 1 1 21.333 0 10.667 10.667 0 0 1-21.333 0m7.4 2.587A4.4 4.4 0 0 0 16 20a4.4 4.4 0 0 0 3.267-1.413 1 1 0 0 1 1.47 1.355A6.38 6.38 0 0 1 16.005 22a6.36 6.36 0 0 1-4.733-2.058.997.997 0 0 1 .058-1.413.997.997 0 0 1 1.413.058zM11.35 14a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0m8-1.333a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666"
  })));
};
export default SvgFaceSmile;